import { NgModule } from '@angular/core';
import {
  AuthService,
  CmsConfig,
  I18nConfig,
  OAuthLibWrapperService,
  provideConfig,
} from 'haba-core';
import { HabaOAuthLibWrapperService } from './services/oauth-lib-wrapper.service';
import { HabaAuthService } from './services/auth.service';
import { USER_ACCOUNT_FEATURE, UserAccountRootModule } from 'haba-featurelibs/user/account/root';
import {
  userAccountTranslationChunksConfig,
  userAccountTranslations,
} from 'haba-featurelibs/user/account/assets';
import {
  userProfileTranslationChunksConfig,
  userProfileTranslations,
} from 'haba-featurelibs/user/profile/assets';
import { UserProfileRootModule, USER_PROFILE_FEATURE } from 'haba-featurelibs/user/profile/root';
import { OauthEmporixModule } from 'haba-emporix';

@NgModule({
  declarations: [],
  imports: [UserAccountRootModule, UserProfileRootModule, OauthEmporixModule],
  providers: [
    { provide: OAuthLibWrapperService, useClass: HabaOAuthLibWrapperService },
    { provide: AuthService, useClass: HabaAuthService },
    provideConfig(<CmsConfig>{
      featureModules: {
        [USER_ACCOUNT_FEATURE]: {
          module: () => import('haba-featurelibs/user/account').then((m) => m.UserAccountModule),
        },
        UserModule: {
          module: () => import('./user.module').then((m) => m.UserModule),
          cmsComponents: [
            'ForgotPasswordComponent',
            'ReturningCustomerLoginComponent',
            'ResetPasswordComponent',
            'AccountOverviewAvatarComponent',
            'RegistrationPendingComponent',
            'AccountOverviewSideNav1Component',
            'UpdatePasswordComponent',
            'UpdateEmailComponent',
            'AccountOrderHistoryComponent',
            'AccountOrderDetailsActionsComponent',
            'AccountOrderDetailsItemsComponent',
            'AccountOrderDetailsTotalsComponent',
            'AccountOrderDetailsShippingComponent',
            'PasswordChangeSuccessComponent',
            'ChildDataOverviewComponent',
            'AccountAddressBookComponent',
            'CustomerDataOverviewComponent',
            'LoginBottomComponent',
          ],
        },
      },
      routing: {
        routes: {
          profile: { paths: ['my-account/profile'] },
          myAccountCustomerData: { paths: ['my-account/account-data'] },
          myAccountMyOrders: { paths: ['my-account/my-orders'] },
          myAccountLoginData: { paths: ['my-account/login-data'] },
          myAccountManageAddress: { paths: ['my-account/address'] },
          myAccountChildrenData: { paths: ['my-account/child-data'] },
          contact: { paths: ['contact'] },
          passwordChangeSuccess: { paths: ['login/pw/change-success'] },
          productAdvisor: { paths: ['product-advisor'] },
        },
      },
    }),
    provideConfig(<I18nConfig>{
      i18n: {
        resources: userAccountTranslations,
        chunks: userAccountTranslationChunksConfig,
      },
    }),
    provideConfig(<CmsConfig>{
      featureModules: {
        [USER_PROFILE_FEATURE]: {
          module: () => import('haba-featurelibs/user/profile').then((m) => m.UserProfileModule),
        },
      },
    }),
    provideConfig(<I18nConfig>{
      i18n: {
        resources: userProfileTranslations,
        chunks: userProfileTranslationChunksConfig,
      },
    }),
  ],
})
export class UserFeatureModule {}
